const Logo = ({ className = "h-10" }) => (
  <img 
    src="/livewifi-logo.png" 
    alt="LiveWifi" 
    className={`${className} w-auto object-contain`}
  />
);

export default Logo;
